<template lang="pug">
.d-flex.flex-column.fill-height.pa-4
  div
    v-list-item.pa-0
      v-list-item-content.py-0
        v-list-item-title: h4 {{ item.name }}
        .text-body-2 {{ item.description }}
      v-list-item-action.my-0.align-self-start
        v-menu(
          offset-y
          min-width="250"
        )
          template(v-slot:activator="{ on }")
            v-btn(
              v-on="on"
              fab
              text
              small
              color="secondary"
            )
              v-icon mdi-menu
          v-list(color="secondary lighten-1" dark)
            v-list-item(
              @click="openCategoryEdit"
            )
              v-list-item-avatar.pr-0
                v-icon mdi-cog
              v-list-item-content
                v-list-item-title Редактировать
            v-list-item(
              @click="openConfirmDelete"
            )
              v-list-item-avatar
                v-icon mdi-delete
              v-list-item-content
                v-list-item-title Удалить анкету

    template(v-if="item.mentoring_categories")
      .text-caption.pt-2 Категории:
      v-chip-group(column)
        tooltip-wrap(
          v-for="category in item.mentoring_categories"
          text="Анкета для заявок"
        )
          template(#reason)
            v-chip(
              v-if="category.pivot.is_for_request"
              x-small label color="white"
            ).text-caption Анкета для заявок
            div {{ category.name }}
          v-chip(
            color="primary"
            label small
          )
            v-icon(
              v-if="category.pivot.is_for_request"
              left small color="yellow darken-3"
            ) mdi-star
            | {{ category.name }}

  .d-flex.my-2.align-center
    h4 Вопросы
    v-chip.ml-2(small color="primary" v-if="attributes") {{ attributes.length || 0 }}
    v-spacer
    tooltip-wrap(text="Добавить вопрос")
      v-btn(
        color="primary" text fab small @click="selectedField = fieldInstance()"
      ): v-icon mdi-plus
  v-list
    v-list-item.grey.lighten-4.mb-2.sdo-radius(
      v-for="(field, idx) in attributes"
      :key="idx"
    )
      v-list-item-icon
        tooltip-wrap(:text="INPUT_TYPES[field.type]")
          v-icon(:color="INPUT_ICONS_COLORS[field.type]") {{ INPUT_ICONS[field.type]}}
      v-list-item-content
        v-list-item-title: strong {{ field.name }}
        v-chip-group(v-if="field.type === INPUTS.variant" column)
          v-chip(v-for="i in field.variants" small color="primary" outlined) {{ i.name }}
        div(v-if="field.type === INPUTS.slider")
          v-chip.pr-0(small outlined color="primary") максимум:
            v-chip(color="primary" small).ml-2.px-4 {{ field.slider_max }}
      v-list-item-action
        v-hover(
          v-slot="{ hover }"
        )
          v-btn(
            :color="hover ? 'error' : 'grey darken-1'"
            small @click="deleteField(field.id, idx)" icon
          ): v-icon(size="20") mdi-delete

  inputs-dialog(
    :editable="isEditableSelectedField"
    :value="selectedField"
    :inputTypes="INPUT_TYPES"
    :additionalFields="additionalField"
    @close="selectedField = null"
    @update="onAddField"
  )
</template>
<script>
import InputsDialog from '@/components/InputsDialog.vue';
import OptionsInput from '@/components/InputFields/OptionsInput.vue';
import QuestionnaireCreateModal from './QuestionnaireCreateModal.vue';

const INPUTS = {
  slider: 1,
  text: 2,
  document: 3,
  images: 4,
  variant: 5,
  url: 6,
};
const INPUT_TYPES = {
  [INPUTS.slider]: 'Слайдер',
  [INPUTS.text]: 'Ввод текста',
  [INPUTS.document]: 'Загрузка документа',
  [INPUTS.images]: 'Загрузка Изображения',
  [INPUTS.variant]: 'Выбор варианта из списка',
  [INPUTS.url]: 'Ввод ссылки',
};
const INPUT_ICONS = {
  [INPUTS.slider]: 'mdi-numeric-1-box-multiple-outline',
  [INPUTS.text]: 'mdi-text-box-multiple-outline',
  [INPUTS.document]: 'mdi-file-document-outline',
  [INPUTS.images]: 'mdi-file-image-outline',
  [INPUTS.variant]: 'mdi-format-list-checkbox',
  [INPUTS.url]: 'mdi-link-variant',
};
const INPUT_ICONS_COLORS = {
  [INPUTS.slider]: 'red',
  [INPUTS.text]: 'blue',
  [INPUTS.document]: 'orange',
  [INPUTS.images]: 'green',
  [INPUTS.variant]: 'primary',
  [INPUTS.url]: 'yellow',
};
const additionalField = {
  [INPUTS.variant]: [
    {
      value: 'variants',
      text: 'Опции',
      rules: 'required',
      component: OptionsInput,
    },
  ],
  [INPUTS.slider]: [
    {
      value: 'slider',
      text: 'максимальное значение слайдера',
      rules: 'required',
      component: 'v-text-field',
      component_attrs: {
        label: 'максимальное значение слайдера',
        outlined: true,
        rounded: true,
      },
    },
  ],
};

const fieldInstance = () => ({
  name: '',
  type: null,
  editable: false,
});

export default {
  components: {
    InputsDialog,
  },
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
      star: false,
      loading: false,
      INPUTS,
      INPUT_TYPES,
      INPUT_ICONS,
      INPUT_ICONS_COLORS,
      additionalField,
      fieldInstance,
      selectedField: null,
      attributes: [],
      isEditableSelectedField: false,
    };
  },
  created() {
    this.getAttributes();
  },
  methods: {
    openCategoryEdit() {
      const selectedCategory = this.item.mentoring_categories
        ? this.item.mentoring_categories.find(({ pivot }) => pivot.is_for_request) : null;
      this.$modals.show('generic-controller', {
        title: 'Редактирование анкеты',
        component: QuestionnaireCreateModal,
        'component-props': {
          initial: {
            id: this.item.id,
            name: this.item.name,
            description: this.item.description,
            mentoring_categories: this.item.mentoring_categories,
            isRequest: !!selectedCategory,
            selected: selectedCategory,
          },
          success: (id) => {
            this.$modals.close();
            this.$emit('update', id);
          },
        },

      });
    },
    openConfirmDelete() {
      this.$modals.show('confirm-controller', {
        title: 'Подтвердите удаление',
        method: async () => {
          await this.$api.mentoring.deleteQuestionnaire(this.item.id);
          this.$emit('deleted');
          this.$modals.close();
        },
      });
    },
    async changeOrgQuestionary() {
      await this.$api.mentoring.updateQuestionnaireOrganization(
        this.$user.organization.id, this.item.id,
      );
      // await this.$api.mentoring.detachQuestionnaireOrganization(
      //   this.$user.organization.id, this.item.id,
      // );
      this.star = !this.star;
    },
    async deleteField(id, idx) {
      await this.$api.mentoring.deleteQuestions(id).then(() => {
        this.attributes.splice(idx, 1);
      });
    },
    async getAttributes() {
      this.attributes = this.item.questions || [];
      await Promise.all(this.attributes.map(async (i, idx) => {
        if (i.type === INPUTS.variant) {
          const res = await this.$api.mentoring.getQuestionsVariants({ 'search[question_id]': i.id });
          this.$set(this.attributes[idx], 'variants', res.data.data);
        }
      }));
    },
    async onAddField() {
      const payload = {
        ...this.selectedField,
        questionnaire_id: this.item.id,
        ...this.selectedField.type === INPUTS.slider
          ? { slider: { min: 0, max: this.selectedField.slider } } : {},
      };
      this.attributes.push({ ...this.selectedField, slider_max: this.selectedField.slider });
      await this.$api.mentoring.createQuestions(payload);
    },
  },
};
</script>
